import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectTownState } from '../selectors';

export const getData = createSelector(selectTownState, (state: State) => state.data);

export const getError = createSelector(selectTownState, (state: State) => state.error);

export const getLoading = createSelector(selectTownState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectTownState, (state: State) => fn(state.data));
